var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"treebox"},[_c('el-tree',{ref:"defaultSearchTree",attrs:{"default-expand-all":true,"data":_vm.searchResult,"props":_vm.defaultProps,"node-key":"id","highlight-current":true},on:{"node-click":_vm.handleNodeClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abaf1cb6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bookstree.vue
// module id = null
// module chunks = 